import { Col, List, Row } from "antd";
import styles from "./VendorPlanningFormTwo.module.css";
import {
  CalendarIcon,
  LocIcon,
  PdfIcon,
  UserIcon,
} from "../../../components/icons/Icons";
import { AntdSwitch, Box, Panel, TextComponent } from "../../../components";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { IoIosRadioButtonOff, IoIosRadioButtonOn } from "react-icons/io";
import { FaCheckSquare, FaRegSquare } from "react-icons/fa";
import { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { PlanningTemplatesMiddleware } from "../../../Store/Middlewares/PlanningTemplatesMiddleware";

import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { saveAs } from "file-saver";
import axios from "axios";

const VendorPlanningFormTwo = () => {
  const {
    state: { ViewResult, parent_id, temp_id, shared_planning_template_id },
  } = useLocation();
  console.log("shared_planning_template_id", shared_planning_template_id);
  const inputRef = useRef(null);
  const [selectedSections, setSelectedSections] = useState([]);
  const [selectedQues, setSelectedQues] = useState([]);
  console.log("selectedSections", selectedSections);
  useEffect(() => {
    let AllQuestion = [];
    ViewResult?.section?.forEach((element) => {
      element?.questions?.forEach((element) => {
        AllQuestion.push(element);
      });
    });
    setSelectedQues(AllQuestion);
  }, []);

  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const dispatch = useDispatch();

  const printDocument = () => {
    if (selectedSections?.length != selectedQues.length) {
      dispatch(
        PlanningTemplatesMiddleware.generatePdf({
          event_id: EventDetails?.id,
          sections: selectedSections,
          title: EventDetails?.name,
          temp_id: temp_id,
          parent_id: parent_id,
          shared_planning_template_id:shared_planning_template_id,
        })
      ).then((response) => {
        // const resp = await axios.get(response.attachment, {
        //   headers: {
        //     "Access-Control-Allow-Origin": "*",
        //   },
        // });
        // resp.blob().then((blob) => {
        // Creating new object of PDF file

        // Setting various property values
        const pdfUrl = `https://www.bestdayever.me/api/downloadFile?path=${response.attachment}`;

        const link = document.createElement("a");
        link.href = pdfUrl;
        link.target = "_blank";
        link.download = response.title; // specify the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // saveAs(response?.attachment, `${response.title}.pdf`);
      });
    } else {
      dispatch(
        showAlert({
          title: "generatePdf",
          message: "Please enable atleast one section",
          type: "error",
        })
      );
    }
  };

  const onSwitch = (item) => {
    let find = selectedSections.find((data) => data.id == item.id);
    if (find) {
      setSelectedSections((prev) => prev.filter((data) => data.id != item.id));

    } else {
      setSelectedSections([...selectedSections, item]);

    }
  };

  console.log("selectedSections", selectedSections);

  const renderSectionList = (item, index) => {
    return (
      <div className={styles.secListItem} key={item?.id}>
        <Panel name={item?.name}>
          {item?.questions?.map((ques, i) => {
            // console.log("ques", ques);

            return (
              <>
                <div className={styles.quesListItem}>
                  <TextComponent text={ques?.question} />
                  <AntdSwitch
                    defaultChecked={true}
                    onChange={() => {
                      onSwitch(ques);
                    }}
                  />
                </div>
                <div className={styles.answer}>
                  {ques?.type == "set_option" ||
                    ques?.type == "multiple_option" ? (
                    <div>
                      {ques?.options?.map((options, index) => {
                        return (
                          <div className={styles.optionItem}>
                            {ques?.type == "multiple_option" ? (
                              ques?.answer?.includes(options?.name) ? (
                                <FaCheckSquare className={styles.optionIcon} />
                              ) : (
                                <FaRegSquare className={styles.optionIcon} />
                              )
                            ) : options?.name == ques.answer ? (
                              <IoIosRadioButtonOn
                                className={styles.optionIcon}
                              />
                            ) : (
                              <IoIosRadioButtonOff
                                className={styles.optionIcon}
                              />
                            )}
                            <TextComponent
                              text={options?.name}
                              textClass={styles.optionText}
                            />
                            {/* <div> */}
                            {/* </div> */}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <TextComponent
                      text={ques?.answer ? ques?.answer : "--"}
                      textClass={styles.optionText}
                    />
                  )}
                </div>
              </>
            );
          })}
        </Panel>
      </div>
    );
  };
  return (
    <Col xs={24}>
      <Row className={styles.topRow} justify={"space-between"}>
        <Col>
          <TextComponent textClass={styles.subtitle}>
            {ViewResult?.event_type}
          </TextComponent>
          <TextComponent textClass={styles.title}>
            {ViewResult?.event_name}
          </TextComponent>
        </Col>
        <Col>
          <Row className={styles.pdfDownloadRow} onClick={printDocument}>
            <PdfIcon size={30} />
            <TextComponent textClass={styles.pdfDownloadText}>
              Download Pdf
            </TextComponent>
          </Row>
        </Col>
      </Row>
      <div className={styles.boxesRow} ref={inputRef}>
        <div className={styles.leftCol}>
          <Row gutter={[0, 16]}>
            <Col xs={24}>
              <Box boxClass={styles.box}>
                <Row className={styles.headingRow}>
                  <Col>
                    <TextComponent textClass={styles.boxHeading}>
                      Event Details
                    </TextComponent>
                  </Col>
                  <Col>{/* <Switch /> */}</Col>
                </Row>
                <Row className={styles.detailRow}>
                  <Col className={styles.leftDetailCol}>
                    <CalendarIcon size={25} />
                    <TextComponent textClass={styles.detailTitle}>
                      Date:
                    </TextComponent>
                  </Col>
                  <Col className={styles.detailValue}>
                    <TextComponent>
                      {moment(ViewResult?.event_date).format("MMMM DD YYYY")}
                    </TextComponent>
                  </Col>
                </Row>

                <Row className={styles.detailRow}>
                  <Col className={styles.leftDetailCol}>
                    <LocIcon size={25} />
                    <TextComponent textClass={styles.detailTitle}>
                      Location:
                    </TextComponent>
                  </Col>
                  <Col className={styles.detailValue}>
                    <TextComponent>{ViewResult?.event_location}</TextComponent>
                  </Col>
                </Row>

                <Row className={styles.detailRow}>
                  <Col className={styles.leftDetailCol}>
                    <UserIcon size={25} />
                    <TextComponent textClass={styles.detailTitle}>
                      Guests:
                    </TextComponent>
                  </Col>
                  <Col className={styles.detailValue}>
                    <TextComponent>
                      {ViewResult?.event_no_of_guest}
                    </TextComponent>
                  </Col>
                </Row>
              </Box>
            </Col>
            <Col xs={24}>
              <Box boxClass={styles.box}>
                <Row className={styles.headingRow}>
                  <Col>
                    <TextComponent textClass={styles.boxHeading}>
                      Note
                    </TextComponent>
                  </Col>
                  <Col>{/* <Switch style={} /> */}</Col>
                </Row>
                <TextComponent textClass={styles.noteText}>
                  {ViewResult?.event_description
                    ? ViewResult?.event_description
                    : "No Note Added Yet"}
                </TextComponent>
              </Box>
            </Col>
          </Row>
        </div>
        <div className={styles.rightCol}>
          <Box boxClass={styles.box} style={{ height: "100%" }}>
            <Row className={styles.headingRow}>
              <Col>
                <TextComponent textClass={styles.boxHeading}>Q/A</TextComponent>
              </Col>
              <Col>{/* <Switch /> */}</Col>
            </Row>
            <div className={styles.qaBoxContainer}>
              {/* <div className={styles.quesCol}> */}
              <List
                dataSource={ViewResult?.section ? ViewResult?.section : []}
                renderItem={renderSectionList}
                className={styles.sectionlist}
              />
              {/* </div> */}
              {/* <Box boxClass={styles.qaBox}>
                <Row className={styles.qaRow}>
                  <Col>
                    <TextComponent textClass={styles.qaBoxTitle}>
                      Engagement Packages
                    </TextComponent>
                  </Col>
                  <Col>
                    <TextComponent textClass={styles.qaRatio}>
                      2/3
                    </TextComponent>
                  </Col>
                </Row>
              </Box>
              <Box boxClass={styles.qaBox}>
                <Row className={styles.qaRow}>
                  <Col>
                    <TextComponent textClass={styles.qaBoxTitle}>
                      Venue Information
                    </TextComponent>
                  </Col>
                  <Col>
                    <TextComponent textClass={styles.qaRatio}>
                      2/5
                    </TextComponent>
                  </Col>
                </Row>
              </Box>
              <Box boxClass={styles.qaBox}>
                <Row className={styles.qaRow}>
                  <Col>
                    <TextComponent textClass={styles.qaBoxTitle}>
                      Event Details
                    </TextComponent>
                  </Col>
                  <Col>
                    <TextComponent textClass={styles.qaRatio}>
                      3/4
                    </TextComponent>
                  </Col>
                </Row>
              </Box> */}
            </div>
          </Box>
        </div>
      </div>
    </Col>
  );
};

export default VendorPlanningFormTwo;
